package it.neckar.lizergy.version

import it.neckar.open.version.Version
import it.neckar.open.version.VersionInformation

/**
 * Application related information
 *
 */
object LizergyVersions {
  val monorepoVersion: String = VersionInformation.version

  /**
   * The commit date and time of the running commit (ISO 8601).
   */
  val gitCommitDateTime: String = VersionInformation.gitCommitDateTime

  val gitCommit: String = VersionInformation.gitHash

  /**
   * Verbose version string that contains the git information
   */
  val gitVersionAsStringVerbose: String
    get() = "$gitCommitDateTime - $gitCommit"

  /**
   * Compact version string for UI display: commit date (no time) plus the short hash.
   * The verbose form (ISO timestamp + full 40-char hash, ~66 chars) blows up narrow layouts —
   * the sidebar's position-fixed footer grew past the sidebar column and intercepted clicks
   * on the main content (the nightly Playwright run went red over exactly this).
   */
  val gitVersionAsStringCompact: String
    get() = "${gitCommitDateTime.take(10)} - ${VersionInformation.gitHashShort}"


  val auth: Version = Version(1, 1, 7)

  val comments: Version = Version(1, 0, 0)

  /**
   * Used for the storage service
   */
  val storage: Version = Version(4, 0, 1)

  val processStates: Version = Version(1, 1, 1)
}
